//配置项
let config = {
  //是否是微信环境
  isWx() {
    return window.navigator.userAgent.toLowerCase().indexOf('micromessenger') >= 0;
  },
  //是否是钉钉环境
  isDD() {
    return window.navigator.userAgent.toLowerCase().indexOf('dingtalk') >= 0;
  },
  //是否是IOS环境
  isIOS() {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('iphone') >= 0 || ua.indexOf('ipad') >= 0 || ua.indexOf('ipod') >= 0;
  },
  //是否是app环境
  isApp() {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.match(/isapp/i) == 'isapp';
  },
  //设置访问的页面地址
  setUrl(path) {
    let url = window.location.href;
    let index = url.lastIndexOf('/');
    let str = url.substring(0, index + 1) + path;
    console.log('str', str);
    return str;
  },
  //获取url后携带的参数
  getQueryValue(name) {
    let urlResult = window.location.href.match(new RegExp('[?&]' + name + '=([^&]+)', 'i'));
    if (urlResult == null || urlResult.length < 1) {
      return null;
    }
    return urlResult[1];
  },
  //获取日期
  getDateStr() {
    const now = new Date();
    let year = now.getFullYear().toString();
    let month = (now.getMonth() + 1).toString();
    let day = now.getDate().toString();
    year = year.toString().substr(-2);
    month = Number(month) < 10 ? '0' + month : month;
    day = Number(day) < 10 ? '0' + day : day;
    return year + month + day;
  },
  //是否是移动端还是PC端
  deviceType() {
    const browser = {
      versions: (function() {
        var u = navigator.userAgent;
        return {
          //移动终端浏览器版本信息
          trident: u.indexOf('Trident') > -1, //IE内核
          presto: u.indexOf('Presto') > -1, //opera内核
          webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
          gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
          mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), //是否为移动终端
          ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
          android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
          iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
          iPad: u.indexOf('iPad') > -1, //是否iPad
          webApp: u.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
        };
      })(),
      language: (navigator.browserLanguage || navigator.language).toLowerCase()
    };
    let flag = false;
    //1.是否mobile，否，肯定不是。
    if (browser.versions.mobile) {
      //2.是否ios或android终端，有一个是
      if (browser.versions.android || browser.versions.ios) {
        flag = true;
        return flag;
      }
    }
    return flag;
  }
};

export default config;
